import script from "./ICMMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ICMMenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./ICMMenuItem.vue?vue&type=style&index=0&id=38bdb640&lang=scss"

const __exports__ = script;

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection});
